module.exports = __webpack_public_path__ + "static/media/B2BProxy.0b942ff5.png";